// Stampa silenziosa in-page tramite iframe nascosto (nessuna nuova scheda)
import { photoUrl } from "./api";

const KEY = "cc_print_settings";

export const printLogoHtml = (logoPath, h = 42) =>
  logoPath ? `<img src="${photoUrl(logoPath)}" style="height:${h}px;border-radius:8px;object-fit:contain;float:right;margin-left:10px" alt="" />` : "";

export const getPrintSettings = () => {
  try { return { width: 80, auto: false, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }; }
  catch { return { width: 80, auto: false }; }
};

export const savePrintSettings = (s) => localStorage.setItem(KEY, JSON.stringify(s));

export function printHtml(html) {
  if (isStandalone() || isMobile()) return overlayPrint(html);
  const f = document.createElement("iframe");
  f.setAttribute("aria-hidden", "true");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
  document.body.appendChild(f);
  const doc = f.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  const cleanup = () => { try { f.remove(); } catch (e) {} };
  try { f.contentWindow.onafterprint = () => setTimeout(cleanup, 500); } catch (e) {}
  setTimeout(() => {
    const win = f.contentWindow;
    const go = () => { try { win.focus(); win.print(); } catch (e) { cleanup(); } };
    let fired = false;
    const fire = () => { if (!fired) { fired = true; go(); } };
    const imgs = [...(win.document.images || [])].filter((i) => !i.complete);
    if (imgs.length) {
      Promise.all(imgs.map((i) => new Promise((r) => { i.onload = r; i.onerror = r; }))).then(() => setTimeout(fire, 120));
      setTimeout(fire, 2500);
    } else fire();
    setTimeout(cleanup, 60000);
  }, 300);
}

// iOS "app da schermata Home" (standalone): window.print() in iframe nascosto è inaffidabile
// e aprire nuove finestre butta fuori dall'app. Mostriamo un'anteprima IN-APP con Stampa/Condividi.
const isStandalone = () => window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
const isIOS = () => /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const isMobile = () => /Android|iP(hone|ad|od)/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && Math.min(window.innerWidth, window.innerHeight) < 900);

function overlayPrint(html) {
  document.querySelector("[data-print-overlay]")?.remove();
  const clean = html.replace(/<script>[\s\S]*?<\/script>/g, "");
  const it = (localStorage.getItem("lang") || "it") === "it";
  const wrap = document.createElement("div");
  wrap.setAttribute("data-print-overlay", "1");
  wrap.setAttribute("data-testid", "print-overlay");
  wrap.style.cssText = "position:fixed;inset:0;z-index:99999;background:#fff;display:flex;flex-direction:column";
  const bar = document.createElement("div");
  bar.style.cssText = "display:flex;gap:8px;padding:10px 12px;padding-top:calc(10px + env(safe-area-inset-top));border-bottom:1px solid #ddd;background:#f7f6f2";
  const mk = (label, primary, tid) => {
    const b = document.createElement("button");
    b.textContent = label;
    b.setAttribute("data-testid", tid);
    b.style.cssText = `flex:1;padding:12px 8px;border-radius:12px;border:0;font-weight:700;font-size:15px;${primary ? "background:#0d1f3d;color:#fff" : "background:#e8e6df;color:#111"}`;
    return b;
  };
  const printBtn = mk(it ? "🖨 Stampa" : "🖨 Print", true, "print-overlay-print");
  const shareBtn = mk(it ? "Condividi" : "Share", false, "print-overlay-share");
  const closeBtn = mk(it ? "✕ Chiudi" : "✕ Close", false, "print-overlay-close");
  const frame = document.createElement("iframe");
  frame.style.cssText = "flex:1;border:0;width:100%;background:#fff";
  bar.append(printBtn, shareBtn, closeBtn);
  wrap.append(bar, frame);
  document.body.appendChild(wrap);
  frame.srcdoc = clean;
  printBtn.onclick = () => {
    try { frame.contentWindow.focus(); frame.contentWindow.print(); }
    catch (e) { try { window.print(); } catch (e2) {} }
  };
  shareBtn.onclick = async () => {
    try {
      const file = new File([clean], "documento.html", { type: "text/html" });
      if (navigator.canShare?.({ files: [file] })) { await navigator.share({ files: [file] }); return; }
      const text = frame.contentWindow?.document?.body?.innerText?.slice(0, 900) || "";
      await navigator.share({ text });
    } catch (e) { /* condivisione annullata */ }
  };
  closeBtn.onclick = () => wrap.remove();
}
